import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
    greyedOutOverlay: {
        zIndex: theme.zIndex.drawer + 1,
        opacity: 0.4,
        filter: 'grayscale(100%)',
        pointerEvents: 'none',
        position: 'relative'
    },
    spinner: {
        zIndex: theme.zIndex.drawer + 2,
        position: 'absolute',
        left: '50%'
    },
    topWhenEmpty: {
        top: 'calc(50% - 20px)',
    },
    topWhenChildren: {
        top: '50%',
    },
    placeholder: {
        visibility: 'hidden',
    },
}));

export const GreyedOutProgressMask = (props: any) => {
    const classes = useStyles();
    const {isActive, children, displaySpinner, containerStyle} = props;

    return (
               <div className={clsx(isActive && classes.greyedOutOverlay)}
            style={containerStyle}>
                        {displaySpinner && isActive && <CircularProgress
                color="inherit"
                className={clsx(classes.spinner, children ? classes.topWhenChildren : classes.topWhenEmpty)}/>}
                        {children || (displaySpinner && isActive && <CircularProgress className={clsx(classes.placeholder)}/>)}
        </div>
    );
};
